// Screen `form-builder` — design/screens/FormBuilder.dc.html — owner: S5.
import { createFileRoute } from '@tanstack/react-router';
import { FormBuilderPage } from '../../../../../features/forms/FormBuilderPage';

export const Route = createFileRoute('/_focus/o/$object/forms/$formId')({
  component: FormBuilderRoute,
});

function FormBuilderRoute() {
  const { object, formId } = Route.useParams();
  return <FormBuilderPage key={`${object}:${formId}`} objectKey={object} formId={formId} />;
}
